module.exports = __webpack_public_path__ + "img/refresh.a7216c68.svg";